import React, {Component} from 'react';
import { object } from 'prop-types'

import WorthyApi from 'lib/api/worthyApi';
import Validators from 'lib/validators';
import {rootUrl} from '../../../helpers/ApplicationHelper';

class FeaturesAndNewsletter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      error: '',
      formSubmitted: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  static propTypes = {
    newsletter: object,
    features: object
  };

  static defaultProps = {
    newsletter:{},
    features: {}
  };

  validate() {
    let error = '';
    let valid = Validators.validateEmail(this.state.email);

    if (!valid) error = !this.state.email ? 'Email field cannot be empty' : 'Email is not valid';

    this.setState({error});

    return valid;
  }

  handleSubmit(e) {
    e.preventDefault();
    let valid = this.validate();

    if (!valid) return;

    WorthyApi.createNewsletterSubscribe(
        {email: this.state.email, origin: 'Homepage App'}).
        then((response) => {
          let data = response.data;
          if (data) {
            this.setState({formSubmitted: true});
          }
        });
  }

  handleChange(e) {
    let valueField = e.target.value;
    this.setState({email: valueField});
  }

  renderNewsletter(newsletter) {
    return !this.state.formSubmitted
        ? <React.Fragment>
          <h3 className="label">
            {newsletter.title}
          </h3>
          <input className='input-email'
                 required
                 onChange={this.handleChange}
                 value={this.state.email}
                 type="text"
                 placeholder={newsletter.input.placeholder}/>
          <span className={'error-input'}>{this.state.error}</span>
          <a className={'btn'}
             onClick={this.handleSubmit}>{newsletter.button}</a>
        </React.Fragment>
        :
        <div className="after-submission">
          <h3>{newsletter.afterSubmission.h3}</h3>
          <h5>{newsletter.afterSubmission.h5}</h5>
        </div>;
  }

  render() {
    let {features: {link, image}, newsletter} = this.props;
    newsletter = this.renderNewsletter(newsletter);

    return (
        <div>
          <div className="features">
            <a href={rootUrl(link)}>
              <img src={image}
                   alt="features image"/>
            </a>
          </div>
          <div className="newsletter">{newsletter}</div>
        </div>
    );
  }
}

export default FeaturesAndNewsletter;